import mbxClient from '@mapbox/mapbox-sdk';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';

const baseClient = mbxClient({
  accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
});
const geocodingClient = mbxGeocoding(baseClient);

export default async function (lngLatObj) {
  if (!geocodingClient.client) return;
  let reverseData = await geocodingClient
    .reverseGeocode({
      query: [lngLatObj.lng, lngLatObj.lat],
      types: ['place', 'locality'],
      countries: ['US']
    })
    .send();

  // console.log('mapbox reverseGeocode --> ', reverseData);
  if (reverseData.statusCode !== 200 || !reverseData.body.features) return;
  const {
    body: { features }
  } = reverseData;

  if (features && features.length && features[0].place_name) {
    return features[0].place_name.replace(', United States', '');
  }
  return;
}
